import '@js/bootstrap'

import {Header} from '@js/components/Header'
import {Slider} from '@js/components/Slider'
import {Archive} from '@js/components/Archive'
import {FormationSingle} from '@js/components/FormationSingle'
import {TeamSingle} from '@js/components/TeamSingle'
import {Map} from '@js/components/Map'
import {DirectAccess} from '@js/components/DirectAccess'
import {YoutubeBg} from '@js/components/YoutubeBg'
import {Lightbox} from '@js/components/Lightbox'
import {Tabs} from '@js/components/Tabs'
import {Mask} from '@js/animations/Mask'
import {Stagger} from '@js/animations/Stagger'
import {Wipe} from '@js/animations/Wipe'
import {Scroll} from '@js/animations/Scroll'
import {Translate} from '@js/animations/Translate'
import {Shape} from '@js/animations/Shape'
import {Zoom} from '@js/animations/Zoom'
import {Fade} from '@js/animations/Fade'
import {Counter} from '@js/animations/Counter'

new YoutubeBg()

window.onload = () => {
  // Lenis avant les ScrollTriggers — sinon les starts (surtout bas de page) sont faussés
  new Scroll()

  const animations = [
    Mask,
    Stagger,
    Wipe,
    Translate,
    Shape,
    Zoom,
    Fade,
    Counter,
  ]

  animations.forEach(animation => {
    new animation()
  })

  new Header()
  new Archive()
  new Slider()
  new FormationSingle()
  new TeamSingle()
  new Map()
  new DirectAccess()
  new Lightbox()
  new Tabs()

}
